
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15287.201 11399.801 55.947 39.404"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_757","data-name":"Group 757","transform":"translate(-16219.5 10883.501)","opacity":".24"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_455","d":"M35.7 26.4l-7.9-9.3-7.8 9.3h5V39h5.7V26.4z","data-name":"Path 455","transform":"translate(932.011 516.004)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_456","d":"M35.6 33.1h11.2c7 0 9.9-7 8.2-11.9-2.3-6.2-8-5.1-8-5.1s-.1-5.2-4.6-7.3a10.4 10.4 0 0 0-8.8.3S30.9 1.2 21.2 1C11.9.8 5.7 9.2 6.7 16.2A8.446 8.446 0 0 0 1 24.8c.3 6.8 6.4 8.9 9.6 8.9H20","data-name":"Path 456","transform":"translate(932.011 516.004)"}})])])
          )
        }
      }
    